import FAQContainer from "../../../Components/Bonus/FAQ";

const FAQ = () => {
  return <FAQContainer />;
};

export default FAQ;
